import {
  useGetDepartmentAndWorkAreaTreeSuspense,
  UserPermission,
} from "@/orval/gen"
import {
  TreePillsInput,
  TreePillsInputProps,
} from "@components/tree/tree-pills-input"
import { useTranslation } from "react-i18next"

export function DepartmentWorkAreaTree(
  props: Omit<TreePillsInputProps<Partial<UserPermission>>, "tree">
) {
  const { data: treeData } = useGetDepartmentAndWorkAreaTreeSuspense({
    permissionArea: "DutyRoster",
  })
  const { t } = useTranslation("app_server")
  return (
    <TreePillsInput
      tree={treeData.tree.filter((node) => node.nodeProps !== null)}
      label={t("Departments")}
      {...props}
    />
  )
}
